import { useRequest } from "../../../hooks/useRequest";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import Utils from "../utils";
import routes from "../../../routes";
import { Outcomes, SolutionPayload } from "../types";
import { AddSolutionFormValues } from "../add/form/types";

function useAddSolutionForm() {
  const { fetch, response, error, loading } = useRequest();
  const { alert, setAlert } = useHttpResponseAlert(
    error,
    response,
    "New project has been added successfully!",
  );

  const handleSubmit = (form: AddSolutionFormValues) => {
    const payload: SolutionPayload =
      Utils.SolutionFormBuilder.addSolution(form);

    const basePayload = Utils.SolutionFormBuilder.removeNonValues(
      payload,
    ) as Omit<SolutionPayload, "outcomes"> & {
      outcomes?: Outcomes;
    };
    const normalizedOutcomes = basePayload.outcomes || [];
    const normalisedPayload = {
      ...basePayload,
      outcomes: {
        v2: normalizedOutcomes,
        v3: normalizedOutcomes,
      },
    };

    const geojsonFile = normalisedPayload?.riskMonitoring?.geospatialFile;

    if (!(geojsonFile instanceof File)) {
      return fetch("POST", routes.api.solution.base.pattern, normalisedPayload);
    }

    const multipartForm = new FormData();
    const solutionMetadata = {
      ...normalisedPayload,
      riskMonitoring: {
        ...normalisedPayload.riskMonitoring,
        geospatialFile: null,
      },
    };

    multipartForm.set("payload", JSON.stringify(solutionMetadata));
    multipartForm.set("file", geojsonFile, geojsonFile.name);
    return fetch(
      "POST",
      routes.api.solution.base.pattern,
      multipartForm,
      undefined,
      false,
    );
  };

  return {
    handleSubmit,
    formSubmittalLoading: loading,
    alert,
    setAlert,
    formError: error,
    formSuccess: response,
  };
}

export default useAddSolutionForm;
